import { setupConfig } from '@ionic/core';
import { applyPolyfills, defineCustomElements } from '@ionic/core/loader';
import { needsKebabCase } from './utils';
/**
* We need to make sure that the web component fires an event
* that will not conflict with the user's @ionChange binding,
* otherwise the binding's callback will fire before any
* v-model values have been updated.
*/
const toLowerCase = (eventName) => eventName === 'ionChange' ? 'v-ionchange' : eventName.toLowerCase();
const toKebabCase = (eventName) => eventName === 'ionChange' ? 'v-ion-change' : eventName.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
/**
 * Vue 3.0.6 fixed a bug where events on custom elements
 * were always converted to lower case, so "ionRefresh"
 * became "ionRefresh". We need to account for the old
 * issue as well as the new behavior where "ionRefresh"
 * is converted to "ion-refresh".
 * See https://github.com/vuejs/vue-next/pull/2847
 */
const getHelperFunctions = (needsKebabCase = true) => {
    const conversionFn = (needsKebabCase) ? toKebabCase : toLowerCase;
    return {
        ael: (el, eventName, cb, opts) => el.addEventListener(conversionFn(eventName), cb, opts),
        rel: (el, eventName, cb, opts) => el.removeEventListener(conversionFn(eventName), cb, opts),
        ce: (eventName, opts) => new CustomEvent(conversionFn(eventName), opts)
    };
};
export const IonicVue = {
    async install(app, config = {}) {
        if (typeof window !== 'undefined') {
            const { ael, rel, ce } = getHelperFunctions(needsKebabCase(app.version));
            setupConfig(Object.assign(Object.assign({}, config), { _ael: ael, _rel: rel }));
            await applyPolyfills();
            await defineCustomElements(window, {
                exclude: ['ion-tabs'],
                ce,
                ael,
                rel
            });
        }
    }
};
//# sourceMappingURL=ionic-vue.js.map